// Notice severities (VISUAL_IDENTITY §4.15): dot colour, label, order on the
// dashboard (most severe first) and whether users may dismiss it. Class
// strings stay literal so Tailwind's JIT sees them.
export const NOTICE_KIND = {
  critical: { label: 'Critical', dot: 'bg-red-500', order: 0, dismissible: false },
  maintenance: { label: 'Maintenance', dot: 'bg-amber-500', order: 1, dismissible: true },
  dst: { label: 'Clock change', dot: 'bg-accent-500', order: 2, dismissible: true },
  info: { label: 'Info', dot: 'bg-brand-500', order: 3, dismissible: true },
};

export const noticeKind = (kind) => NOTICE_KIND[kind] || NOTICE_KIND.info;

// A notice can pin itself (the clock change in its last days): it then
// cannot be dismissed and ranks right after critical ones.
export const isDismissible = (notice) => noticeKind(notice.kind).dismissible && !notice.pinned;

const rank = (notice) => (notice.pinned ? 0.5 : noticeKind(notice.kind).order);

export const sortNotices = (notices) => [...notices].sort((a, b) => rank(a) - rank(b));

// Dismissals key on (id, updated_at), so editing a notice shows it again.
export const noticeDismissKey = (notice) => `${notice.id}@${notice.updated_at}`;
